<template>
  <div id="app" class="h-100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @import "../static/css/main.css";
</style>


// WEBPACK FOOTER //
// App.vue?ba640b82